import React from 'react';
import styled from 'styled-components';
import { Link as RRLink } from 'react-router-dom';
import ROUTES from 'constants/ROUTES';
import { useLocalStorage } from 'react-use';
import { getAssetsUrl } from 'utilities';

import { Layout as PageLayout, AnimatedFrames } from 'components';

const Cover = styled.div`
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
`;

const Container = styled.div`
  min-width: 0;
`;

const Image = styled.img`
  max-width: 100%;
`;

const yellow = '#DFF27C';
const blue = '#52449D';
const dark = '#2D2828';

const Link = styled(RRLink)`
  max-width: 100%;
  width: 450px;
  height: 70px;
  font-weight: bold;
  color: ${yellow};
  padding: 8px;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  box-shadow: 0 0 0 1px inset rgba(223, 242, 124, 0.3);
  position: relative;

  &:after,
  &:before {
    content: '';
    width: 1px;
    position: absolute;
    height: 8px;
    background: #0f1923;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  &:before {
    right: 0;
    left: initial;
  }
  p {
    background-color: ${dark};
    margin: 0;
    height: 54px;
    line-height: 54px;
    z-index: 1;
    left: 0;
    width: 100%;
    position: relative;
    overflow: hidden;
    span.base {
      box-sizing: border-box;
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      left: 0;
      border: 1px solid ${yellow};
      &:before {
        content: '';
        width: 2px;
        height: 2px;
        left: -1px;
        top: -1px;
        background: #0f1923;
        position: absolute;
        transition: 0.3s ease-out all;
      }
    }
    span.bg {
      left: -5%;
      position: absolute;
      background: ${yellow};
      width: 0;
      height: 100%;
      z-index: 3;
      transition: 0.3s ease-out all;
      transform: skewX(-10deg);
    }
    span.text {
      z-index: 4;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      white-space: nowrap;
      &:after {
        content: '';
        width: 4px;
        height: 4px;
        right: 0;
        bottom: 0;
        background: #0f1923;
        position: absolute;
        transition: 0.3s ease-out all;
        z-index: 5;
      }
    }
  }
  &:hover {
    color: ${dark};
    span.bg {
      width: 110%;
    }
    span.text:after {
      background: white;
    }
  }
`;

const Button = (props) => (
  <Link className={props.className} to={props.to} onClick={props.onClick}>
    <p>
      <span className="bg"></span>
      <span className="base"></span>
      <span className="text">{props.children}</span>
    </p>
  </Link>
);

const Warn = styled.p`
  opacity: 0.6;
  max-width: 450px;
  margin: 0 auto;
  letter-spacing: 0;
`;

const Layout = styled(PageLayout)`
  background-image: url(${getAssetsUrl('landing/wood.png')});
  background-size: auto 100%;
`;

export default function RootPage() {
  const [value, setValue, remove] = useLocalStorage(
    'landbot-halloween-started'
  );

  return (
    <Layout>
      <AnimatedFrames />
      <Container className="container has-text-centered">
        <Cover>
          <Image
            className="my-6 pt-6"
            src={getAssetsUrl('landing/text.png')}
          />
          <div>
            <Button
              className="is-size-6 is-inline-block"
              to={ROUTES.GAME.ROOT}
              onClick={() => setValue('1')}
            >
              PLAY
            </Button>
            <Warn className="is-size-7 is-hidden-tablet">
              For a fully interactive experience, we recommend you to play this game on a <strong>desktop</strong>.
            </Warn>
          </div>

          {value && (
            <>
              <p className="my-3">or</p>
              <div>
                <Button
                  className="is-size-6 is-size-7-mobile is-inline-block"
                  to={ROUTES.GAME.ACT_4}
                >
                  Customize your own experience
                </Button>
              </div>
            </>
          )}
        </Cover>
      </Container>
    </Layout>
  );
}
